var React = require('react');

function Transfers (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M19 4H5a1 1 0 00-1 1v12.5a.49.49 0 00.84.35l5.25-5.25-1.88-1.88a.41.41 0 01.21-.7l6.32-1.24a.4.4 0 01.48.48L14 15.58a.41.41 0 01-.7.21l-1.9-1.88-5.25 5.25a.49.49 0 00.35.84H19a1 1 0 001-1V5a1 1 0 00-1-1z","fill":"#001b35","key":1})]);
}

Transfers.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 24 24"};

module.exports = Transfers;

Transfers.default = Transfers;
